import { render, staticRenderFns } from "./invoiceCompanyShow.vue?vue&type=template&id=5c3cee12&scoped=true"
import script from "./invoiceCompanyShow.vue?vue&type=script&lang=js"
export * from "./invoiceCompanyShow.vue?vue&type=script&lang=js"
import style0 from "./invoiceCompanyShow.vue?vue&type=style&index=0&id=5c3cee12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3cee12",
  null
  
)

export default component.exports